import { Button, Grid, TextField, Paper, TableFooter, TablePagination } from "@material-ui/core";
import {
  createStyles, makeStyles,
  Theme, withStyles
} from "@material-ui/core/styles";
import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { useEffect } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Api from "../../../../helpers/api";
import { useHistory } from "react-router-dom";
import Divider from '@mui/material/Divider';
import { StyledTableCell, StyledTableRow } from "../../containers/StyledTableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import {
  getProjects,
  getProjectSampleAllData,
  UploadStorage,
  uploadMediaFiles,
  updateProject,
  uploadReport,
} from "../../store/actions";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    table: {
      minWidth: 700,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    paper: {
      marginTop: "2rem",
      padding: "0.5rem 2rem 2rem 2rem",
      width: "100%",
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 40px 10px",
      minHeight: "64px",
    },
    leftContentHeader: {
      width: "50%",
      float: "left",
    },
    rightContentHeader: {
      width: "50%",
      float: "right",
      textAlign: "right",
      paddingRight: "20px",
    },
    buttonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    head: {
      textAlign: "center",
      fontWeight: "normal",
      marginBottom: "2rem",
    },
    slotContainer: {
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
    },
    slot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      margin: "0.5rem",
    },
    hoveItem: {
      cursor: "pointer",
    },
    selectedSlot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(60deg, cyan, #00dfff, cyan)",
      cursor: "pointer",
      margin: "0.5rem",
    },
    chips: {
      display: "flex",
    },
    chip: {
      margin: 2,
      background: "linear-gradient(60deg, cyan, #00cfff, cyan)",
      maxWidth: "130px",
    },
    input: {
      padding: "1px",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
    card: {
      height: "100%",
      padding: "20px",
    },
    cardContent: {
      textAlign: "center",
    },
    center: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    text: { color: "black" },
  })
);

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean
  }
}
interface Props {
  getProjects: any;
  projects: any;
  getProjectSampleAllData: any;
  sampleAllData: any;
  UploadStorage: any;
  uploadMediaFiles: any;
  mediaUpload: any;
  updateProject: any;
  uploadReport: any;
}
const StopsPlace: React.FC<Props> = ({
  getProjects,
  projects,
  getProjectSampleAllData,
  sampleAllData,
  UploadStorage,
  uploadMediaFiles,
  mediaUpload,
  updateProject,
  uploadReport,

}) => {
  const [project, setProject] = React.useState<any>("");
  const [page, setPage] = useState(0);
  const [file, setFile] = React.useState<any>("");
  const [sampleUploadId, setSampleUploadId] = React.useState<any>("");
  const history = useHistory();
  const timer = useRef<any>(0);
  const classes = useStyles();
  const [fileKey, setFileKey] = useState<string>(Math.random().toString(36));
  const [uploading, setUploading] = useState<boolean>(false);
  const [mediaFile, setMediaFile] = useState<any>({
    "libraryQcReport": "",
  });
  const fileSelectedHandler = async (e: React.ChangeEvent<{ files: any }>, type: any) => {
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    setUploading(true);
    Api.post("/media", formData).then((data: any) => {
      setMediaFile({
        ...mediaFile,
        [type]: data?.path,
      })
      setUploading(false);
    }).catch(() => {
      setUploading(false);
    });
  };
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = projects.links && projects.links.next.split("?")[1];
      getProjects(`?${url}`);
    } else if (newPage < page) {
      let url = projects.links && projects.links.previous.split("?")[1];
      getProjects(`?${url}`);
    }
    setPage(newPage);
  };

  const uploadStorageFile = async (e: any) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("file", file);
    await UploadStorage(formData);
    setMediaFile("");
  };
  const handleAddFile = async (e: any) => {
    e.preventDefault();
    const filterPath = mediaFile
    const sampleQcdata = {
      libraryQcReport: filterPath?.libraryQcReport,
    }

    await uploadReport(sampleQcdata, project?._id);
    setMediaFile("");
    setFileKey(Math.random().toString(36));
    getProjects();

  };
  useEffect(() => {
    getProjects();

  }, []);
  const handleExport = () => {
    getProjectSampleAllData(`?project=${project?._id}&limit=2500`);
  };

  return (
    <Grid container spacing={2} style={{ marginTop: 20 }}>
      <Grid container xs={12}>
        <form onSubmit={uploadStorageFile} style={{ width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="Project"
                onChange={(event, newValue) => {
                  setProject(newValue);
                }}
                options={projects?.results || []}
                blurOnSelect
                getOptionLabel={(option: any) => {
                  return (
                    (option?.projectId) +
                    " " +
                    (option?.institute?.name || "") +
                    " " +
                    (option?.scientist?.name || "") +
                    "," +
                    (option?.dealer?.firmName || "")
                  );
                }}
                onInputChange={(event, newInputValue) => {
                  let data = newInputValue.split(" ");
                  clearTimeout(timer.current);
                  timer.current = setTimeout(() => {
                    if (data.length > 0) {
                      getProjects(`?projectId=${data[0]}`);
                    }
                  }, 1000);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="input"
                    label="Project ID"
                    placeholder="Search ID/Client/Dealer Name"
                    variant="outlined"
                    style={{ marginTop: 10 }}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <sup
                style={{
                  fontSize: "11px",
                  marginLeft: "15px",
                  marginTop: "15px",
                  background: "#fff",
                  color: "rgba(0, 0, 0, 0.54)",
                  letterSpacing: "0.00938em",
                }}
              >
                Library Report
              </sup>
              <input
                className={classes.input}
                style={{
                  width: "100%",
                  height: "46px",
                  marginTop: "-15px",
                  padding: "11.5px 14px",
                  border: "1px solid rgba(0, 0, 0, 0.23)",
                  borderRadius: "5px",
                }}
                type="file"
                name="file"
                id="file"
                key={`${fileKey}qcreport`}
                onChange={(e: any) => fileSelectedHandler(e, "libraryQcReport")}

              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Button
                style={{ backgroundColor: "#9c27b0", color: "white", marginTop: 10 }}
                variant="contained"
                fullWidth
                onClick={handleAddFile}
                disabled={uploading || project === ""}
              >
                Upload
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Button
                style={{ backgroundColor: "#ad170c", color: "white", marginTop: 10 }}
                variant="contained"
                fullWidth
                onClick={() => history.go("/dashboard/gnrelab/sample_export")}

              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </form>
        {/* <div>
          {reset && uploadRatelistData?.error !== undefined
            ? JSON.stringify(uploadRatelistData.error).replace(
              /"|{|}|[|]/g,
              ""
            )
            : ""}
        </div> */}
      </Grid>
      <Grid container spacing={2} style={{ marginTop: 20 }}>
        <Grid container style={{ marginTop: 10 }}>
          <TableContainer
            className={classes.tableContainer}
            component={Paper}
            style={{ maxHeight: "480px" }}
          >
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="center">
                    Project Id
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    Library Report
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              {/* dummy data  */}
              <TableBody>
                {projects && projects?.results?.map((data: any, index: any) => {
                  return (
                    <StyledTableRow key={data?._id} >
                      <StyledTableCell align="center">
                        {data?.projectId}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {data?.libraryQcReport ?
                          <a href={data?.libraryQcReport} target="_blank" rel="noreferrer">View</a>
                          : "N/A"}
                      </StyledTableCell>
                    </StyledTableRow>
                  )
                })
                }
              </TableBody>
              <TableFooter>
                <TablePagination
                  rowsPerPageOptions={[]}
                  colSpan={3}
                  count={projects?.count || 0}
                  rowsPerPage={projects?.page_size}
                  page={page}
                  onPageChange={handleChangePage}
                />
              </TableFooter>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Grid>
  );
};
const mapStateToProps = (state: any) => ({
  projects: state.GenomicsLabReducer.projects,
  sampleAllData: state.GenomicsLabReducer.sampleAllData,
  mediaUpload: state.GenomicsLabReducer.mediaUpload,
});
export default connect(mapStateToProps, {
  getProjects,
  getProjectSampleAllData,
  UploadStorage,
  uploadMediaFiles,
  updateProject,
  uploadReport,

})(StopsPlace);
